import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccfd9734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "text-sm font-semibold uppercase" }
const _hoisted_4 = {
  key: 0,
  class: "flex items-center flex-col justify-center select-none text-sm p-4"
}
const _hoisted_5 = { class: "text-red-500" }
const _hoisted_6 = {
  key: 2,
  class: "text-gray-400"
}
const _hoisted_7 = { class: "grid grid-cols-4 gap-6 p-4" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "MonitoringStats__value MonitoringStats__total" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "MonitoringStats__hint" }, "Всего", -1))
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "MonitoringStats__value" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "MonitoringStats__hint" }, "Завершено", -1))
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = { class: "MonitoringStats__value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "MonitoringStats__hint" }, "Остаток", -1))
const _hoisted_17 = { class: "MonitoringStats__trigger flex flex-col relative" }
const _hoisted_18 = { class: "MonitoringStats__value" }
const _hoisted_19 = { class: "MonitoringStats__hint" }
const _hoisted_20 = {
  key: 0,
  class: "MonitoringStats__tooltip"
}
const _hoisted_21 = { class: "grid grid-cols-1" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = {
  key: 0,
  class: "sector__value"
}
const _hoisted_24 = {
  key: 1,
  class: "sector__value"
}
const _hoisted_25 = { class: "sector__name" }
const _hoisted_26 = { class: "font-bold" }
const _hoisted_27 = { class: "flex flex-col" }
const _hoisted_28 = {
  key: 0,
  class: "sector__value"
}
const _hoisted_29 = {
  key: 1,
  class: "sector__value"
}
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = {
  key: 0,
  class: "sector__value"
}
const _hoisted_32 = {
  key: 1,
  class: "sector__value"
}
const _hoisted_33 = { class: "flex flex-col" }
const _hoisted_34 = {
  key: 0,
  class: "sector__value"
}
const _hoisted_35 = {
  key: 1,
  class: "sector__value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["MonitoringStats bg-white rounded", { 'border border-blue-500': _ctx.state.is_opened }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["py-3 px-4 flex items-center justify-between", { 'cursor-pointer': _ctx.isCanExpand }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSectors && _ctx.toggleSectors(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.img)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "mr-3",
              src: _ctx.img,
              alt: _ctx.title
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1)
      ]),
      (_ctx.isCanExpand)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["fas fa-chevron-down transition-all", { 'fa-rotate-180': _ctx.state.is_opened }])
          }, null, 2))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", null, [
      (_ctx.loading || _ctx.failed || _ctx.getStatistics.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.errorText), 1),
                    _createVNode(_component_the_button, {
                      class: "primary small mt-1",
                      onClick: _ctx.emitReload
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Обновить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.getStatistics.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.emptyText), 1))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.total), 1),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.totalCompleted), 1),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.totalRemained), 1),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.totalCancelled), 1),
                _createElementVNode("span", _hoisted_19, [
                  (_ctx.isDelivery)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Возврат на склад")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("Отменено")
                      ], 64))
                ]),
                (_ctx.isCouriers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " Возврат на склад и Отмененные заборы "))
                  : _createCommentVNode("", true)
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStatistics, (stat, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "MonitoringStats__sector grid-cols-4",
                  key: `MonitoringStat-${i}`
                }, [
                  _createElementVNode("div", _hoisted_22, [
                    (_ctx.isCouriers)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(stat.totalTakes) + " / " + _toDisplayString(stat.totalDeliveries), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(stat.total), 1)),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.isCouriers ? 'Курьер' : 'Сектор'), 1),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.isCouriers ? stat.fullName : stat.name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.isCouriers)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(stat.completedTakes) + " / " + _toDisplayString(stat.completedDeliveries), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(stat.completed), 1))
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.isCouriers)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(stat.remainedTakes) + " / " + _toDisplayString(stat.remainedDeliveries), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(stat.remained), 1))
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    (_ctx.isCouriers)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(stat.cancelledTakes) + " / " + _toDisplayString(stat.cancelledDeliveries), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(stat.cancelled), 1))
                  ])
                ]))
              }), 128))
            ], 512), [
              [_vShow, _ctx.state.is_opened]
            ])
          ], 64))
    ])
  ], 2))
}